module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/99d02fcf3c99628bd845723907dd4184.png";